import { render, staticRenderFns } from "./answer-drawer.vue?vue&type=template&id=7500095e&"
import script from "./answer-drawer.vue?vue&type=script&lang=js&"
export * from "./answer-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports